import React, { useEffect, useState } from "react";
import {
	Badge,
	Button,
	Card,
	Col,
	Container,
	OverlayTrigger,
	Row,
	Tooltip,
} from "react-bootstrap";
import { PiNetworkFill } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { GiArchiveResearch, GiWallet } from "react-icons/gi";
import { GiTwoCoins } from "react-icons/gi";
import Header from "../../componets/Header";
import { HiOutlineWallet } from "react-icons/hi2";
import { FcDataConfiguration } from "react-icons/fc";
import { GrTransaction } from "react-icons/gr";
import { FaCoins } from "react-icons/fa6";
import MainService from "../../helper/mainService";
import ApiService from "../../helper/api";
import AlertService from "../../helper/alertService";

const dashboardItems = [
	// {
	// 	title: "System Wallets",
	// 	path: "/system-wallets",
	// 	icon: <GiWallet size={40} />,
	// },
	{
		title: "Merchant Wallets",
		path: "/merchant-wallets",
		icon: <HiOutlineWallet size={40} />,
	},
	{
		title: "Network Platforms",
		path: "/network-platforms",
		icon: <PiNetworkFill size={40} />,
	},
	{
		title: "Coins",
		path: "/coins",
		icon: <GiTwoCoins size={40} />,
	},
	{
		title: "Scanner",
		path: "/scanner",
		icon: <GiArchiveResearch size={40} />,
	},
	{
		title: "Transaction",
		path: "/transaction",
		icon: <GrTransaction size={40} />,
	},
	{
		title: "Configs",
		path: "/configs",
		icon: <FcDataConfiguration size={40} />,
	},
];

const getIcon = platformName => {
	switch (platformName.toLowerCase()) {
		case "ethereum":
			return <FaCoins size={30} />;
		case "solana":
			return <FaCoins size={30} />;
		case "stellar":
			return <FaCoins size={30} />;
		case "tron":
			return <FaCoins size={30} />;
		default:
			return <FaCoins size={30} />;
	}
};

const copyToClipboard = async text => {
	if (!navigator.clipboard) {
		AlertService.alert("error", "Copying is not supported in this browser");
		return false;
	}

	try {
		await navigator.clipboard.writeText(text);
		AlertService.alert("success", "Address copied to clipboard ✅");
		return true;
	} catch (err) {
		AlertService.alert("error", "Failed to copy text ❌");
		return false;
	}
};

const shortText = text =>
	text.length > 20 ? `${text.slice(0, 10)}...${text.slice(-6)}` : text;

const eth_min_value_main_wallet = 0.005;
const trx_min_value_main_wallet = 5000;

const Home = () => {
	const navaigate = useNavigate();
	const [data, setData] = useState([]);
	const [walletInfoId, setWalletInfoId] = useState([]);

	useEffect(() => {
		getSystemWallets();
	}, []);

	useEffect(() => {
		if (!walletInfoId?.length) return;

		const interval = setInterval(() => {
			getSystemWalletsBalance(walletInfoId);
		}, 10 * 60 * 1000);

		return () => clearInterval(interval);
	}, [walletInfoId]);

	const getSystemWalletsBalance = async ids => {
		try {
			const updatedData = await Promise.all(
				ids.map(async id => {
					const response = await MainService.callApi({
						api: ApiService.walletGetWalletBalance,
						data: id,
						showSpinner: false,
					});

					return {
						id,
						walletInfo: response?.data
							? { ...response.data, show: true }
							: null,
					};
				}),
			);

			setData(prev =>
				prev.map(item => {
					const found = updatedData.find(u => u.id === item.id);
					return found ? { ...item, walletInfo: found.walletInfo } : item;
				}),
			);
		} catch (error) {}
	};

	const getSystemWallets = async () => {
		try {
			const walletsResponse = await MainService.callApi({
				api: ApiService.getSystemWallets,
			});

			if (!walletsResponse?.data?.length) return;

			const wallets = walletsResponse.data;

			const walletsWithBalance = await Promise.all(
				wallets.map(async wallet => {
					const balanceResponse = await MainService.callApi({
						api: ApiService.walletGetWalletBalance,
						data: wallet.id,
					});

					return {
						...wallet,
						walletInfo: balanceResponse?.data
							? { ...balanceResponse.data, isLowBalance: true }
							: null,
					};
				}),
			);
			setWalletInfoId(
				walletsWithBalance
					.map(wallet => {
						if (wallet.walletInfo && Object.keys(wallet.walletInfo).length) {
							return wallet.id;
						}
					})
					.filter(Boolean),
			);
			setData(walletsWithBalance);
		} catch (error) {
			console.error("Error loading wallets:", error);
		}
	};

	console.log(walletInfoId);

	const getWolletInfos = (data = []) => {
		if (!data.length) return false;
		const newData = [...data];
		data.forEach(wallet => {
			MainService.callApi({
				api: ApiService.walletGetWalletBalance,
				data: wallet.id,
				cb: response => {
					if (response.data) {
						newData = data.map(el =>
							el.id === wallet.id
								? { ...el, walletInfo: { ...response.data, show: true } }
								: el,
						);
					}
				},
			});
		});
		return newData;
	};

	const getWolletInfo = walletId => {
		if (!walletId) return false;
		MainService.callApi({
			api: ApiService.walletGetWalletBalance,
			data: walletId,
			cb: response => {
				if (response.data) {
					setData(
						data.map(el =>
							el.id === walletId
								? { ...el, walletInfo: { ...response.data, show: true } }
								: el,
						),
					);
				} else {
					AlertService.alert("error", "No Information");
					return null;
				}
			},
		});
	};

	return (
		<div>
			<Header>
				<div className="d-flex justify-content-center w-100">
					<h4 className="mb-0">Welcome to the Cryllex Cryptanalysis Project</h4>
				</div>
			</Header>
			<Container
				fluid
				style={{ paddingBlockEnd: "40px", marginTop: "40px" }}
				className="d-flex flex-column gap-4">
				<Row className="g-4 ">
					{data.map(wallet => (
						<Col md={12} lg={6} key={wallet.id} className="mt-3">
							<div className="premium-card p-4 h-100">
								<div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
									<h5 className="mb-0">{wallet.platformName}</h5>
									{getIcon(wallet.platformName)}
								</div>
								<OverlayTrigger
									placement={"bottom"}
									overlay={
										<Tooltip id={`tooltip-wallet-address`}>
											<span>
												<small>Copy</small>
											</span>
										</Tooltip>
									}>
									<p
										className="mb-2 cursor-pointer hover-shadow d-inline"
										// title="Copy"
										onClick={() => copyToClipboard(wallet.address)}>
										<strong>Address:</strong> <br /> {shortText(wallet.address)}
									</p>
								</OverlayTrigger>

								<p className="mb-3">
									<strong>Public Key:</strong> <br />{" "}
									{shortText(wallet.publicKey)}
								</p>

								{!!wallet?.walletInfo?.chains.length &&
									wallet?.walletInfo?.chains.map((chain, i) => (
										<React.Fragment key={i}>
											<hr className="bg-light" />

											<div className="mb-3 ">
												<div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
													<div className="d-flex align-items-center mb-1 contract-item gap-2">
														<img
															src={chain.chainLogo}
															alt={chain.currencySlug}
															width={30}
														/>
														<h5 className="mb-0">{chain.chainName}</h5>
													</div>
													<Badge bg="info">
														<div className="d-flex align-items-center gap-1">
															<span>{chain.chainBalance.toFixed(6)}</span>
															{chain.currencyLogo && (
																<img
																	src={chain.currencyLogo}
																	alt={chain.currencySlug}
																	width={16}
																	// className="me-2"
																/>
															)}
															(<span>{chain.currencySlug}</span>)
														</div>
													</Badge>
												</div>

												{chain.contracts.map((c, j) => (
													<div
														key={j}
														className="d-flex align-items-center mb-1 contract-item">
														<img
															src={c.logo}
															alt={c.name}
															width={24}
															className="me-2"
														/>
														<div>
															<div>
																{c.name} ({c.slug})
															</div>

															<small className="text-muted d-block">
																Balance: {c.contractBalance}
															</small>
															<OverlayTrigger
																placement={"bottom"}
																overlay={
																	<Tooltip
																		id={`tooltip-wallet-contractAddress`}>
																		<span>
																			<small>Copy</small>
																		</span>
																	</Tooltip>
																}>
																<small
																	className="ms-2 cursor-pointer "
																	title="Copy"
																	onClick={() =>
																		copyToClipboard(c.contractAddress)
																	}>
																	{shortText(c.contractAddress)}
																</small>
															</OverlayTrigger>
														</div>
													</div>
												))}
											</div>
										</React.Fragment>
									))}
								{!!wallet?.walletInfo && (
									<Button
										className="copy-btn"
										onClick={() => getWolletInfo(wallet.id)}>
										{!!wallet?.walletInfo?.chains.length
											? "Update"
											: "Show more info"}
									</Button>
								)}
							</div>
						</Col>
					))}
				</Row>
				<Row className="g-4 mt-4">
					{dashboardItems.map((item, index) => (
						<Col key={index} xs={12} sm={6} md={4} lg={3}>
							<Link to={item.path} className="text-decoration-none">
								<Card className="dashboard-card h-100 shadow-sm">
									<div className="icon-wrapper">{item.icon}</div>

									<Card.Body className="text-center d-flex flex-column justify-content-between">
										<Card.Title>{item.title}</Card.Title>

										<Button
											variant="primary"
											size="sm"
											className="px-4 mt-3 align-self-center">
											View
										</Button>
									</Card.Body>
								</Card>
							</Link>
						</Col>
					))}
				</Row>
			</Container>
		</div>
	);
};

export default Home;
